import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class RequestsSelectionService {
    private forceSource = new Subject<string>();

    requestsForced$ = this.forceSource.asObservable();

    forceSelectCongtragent(value: string) {
        this.forceSource.next(value);
    }
}